import CampingAjaxForm from './CampingAjaxForm';
import DestinationAccommodationTypeCampSelector from './DestinationAccommodationTypeCampSelector';
import ChildrenAgeInput from './ChildrenAgeInput';
import WindowModal from '../modals/WindowModal';
import ContentProviderDirect from '../lib/modals/content_providers/ContentProviderDirect';
import { tooltips } from '../tooltips';

class ContactAjaxForm extends CampingAjaxForm {
  constructor(elements, modal) {
    super(elements);
    this.modal = modal;
    tooltips.init();
  }

  initWidgets(data) {
    let selectedCamps = [];
    super.initWidgets(data);
    if (data !== undefined && data.selected_camps !== undefined) {
      selectedCamps = data.selected_camps;
    }
    this.campSelectorWidget = new DestinationAccommodationTypeCampSelector({
      destination_selector: document.getElementById('id_contact-destination'),
      accommodation_type_selector: document.getElementById('id_contact-accommodation_type'),
      camp_selector: document.getElementById('id_contact-camp'),
    }, {
      accommodation_types_url: CampingAdriaticGlobals.accommodation_types_url,
      camps_url: CampingAdriaticGlobals.camps_url,
    }, CampingAdriaticGlobals.translations, selectedCamps);
    this.childrenAgeInputWidget = new ChildrenAgeInput({
      num_of_children_selector: document.getElementById('id_contact-children'),
      children_age_input: document.getElementById('id_contact-children_age'),
      num_of_children_selector_container: document.querySelector('.js-guests-section'),
    }, CampingAdriaticGlobals.translations);
    let contactUrlElement = document.getElementById('id_contact-url');
    if (contactUrlElement) {
      contactUrlElement.value = window.location.href;
    }
  }

  uninitWidgets() {
    super.uninitWidgets();
    if (this.campSelectorWidget !== undefined) {
      this.campSelectorWidget.uninit();
      delete this.campSelectorWidget;
    }
  }

  parseResponseSuccess(responseData) {
    this.modal.swapModal(new WindowModal(new ContentProviderDirect(responseData.html)));
  }

  getJSONFormData() {
    const jsonData = super.getJSONFormData();
    if (jsonData['contact-camp'] === undefined) {
      jsonData['contact-camp'] = [];
    }
    if (!Array.isArray(jsonData['contact-camp'])) {
      jsonData['contact-camp'] = [jsonData['contact-camp']];
    }
    return jsonData;
  }
}

export default ContactAjaxForm;


// WEBPACK FOOTER //
// ./src/js/forms/ContactAjaxForm.js